import { Icon } from "@components/Icon";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import { FilterContext } from "~/providers/FilterProvider";
import { Filter } from "@usereactify/search";
import React, { useContext, useState } from "react";
import tw from "twin.macro";
import { FilterSection } from "./FilterSection";
import { FilterSectionListSelector } from "./FilterSectionListSelector";
import { FilterSectionProductStats } from "./FilterSectionProductStats";
import { FilterSectionRange } from "./FilterSectionRange";
import { FilterSectionSelectedFilters } from "./FilterSectionSelectedFilters";
import { FilterSectionSort } from "./FilterSectionSort";
import { Button, useProductImage } from "@bared/ui";

const FilterHeader = tw.div`
  flex flex-col w-full xl:border-b
`;

const FilterHeaderLeft = tw.div`
  flex-none self-start pb-mini text-left lg:pointer-events-none pointer-events-auto
`;

const FilterHeaderLeftIcon = tw(Icon)`
  mr-micro align-middle
`;

const FilterHeaderLeftTitle = tw.span`
  leading-h2 font-body text-center underline underline-offset-4 lg:no-underline
`;

const FilterHeaderCenter = tw.div`
  grow self-end lg:hidden
`;

const FilterHeaderRight = tw.div`
  flex-none self-end text-right lg:hidden
`;

const FilterSelectedDesktop = tw.div`
  w-full lg:block flex mt-mini
`;

const FilterSections = styledWithInvalidProps("div")(
  ({ open }: { open: boolean }) => [
    tw``,
    open ? tw`block` : tw`hidden lg:block`,
  ],
);

const FilterContainer = tw.div`
  xl:block sticky top-[122px] overflow-y-auto max-h-90vh z-20 pb-mega
`;

export const FiltersDesktop = () => {
  const { filters, sortOption, sortOptions, setSortOption, showViewToggle } =
    useContext(FilterContext);
  const { showHoverImages, toggleHoverImages } = useProductImage();
  const [show, setShow] = useState(false);
  return (
    <FilterContainer>
      <FilterHeader>
        <div className="flex w-full flex-row justify-between">
          <FilterHeaderLeft onClick={() => setShow((show) => !show)}>
            <FilterHeaderLeftIcon
              name={show ? "filterThreadActiveIcon" : "filterThreadDefaultIcon"}
              size="xxs"
            />
            <FilterHeaderLeftTitle>Filters</FilterHeaderLeftTitle>
          </FilterHeaderLeft>
          {showViewToggle && (
            <div className="flex items-start">
              <Button
                variant="secondary"
                size="xsmall"
                className="p-0 z-50 mr-micro w-[95px]"
                onClick={toggleHoverImages}
                aria-label="Toggle hover images"
              >
                {showHoverImages ? "Product View" : "Model View"}
              </Button>
            </div>
          )}
          <FilterHeaderCenter>
            <FilterSectionProductStats />
          </FilterHeaderCenter>
          <FilterHeaderRight>
            <FilterSectionSort
              sortOption={sortOption}
              sortOptions={sortOptions}
              setSortOption={setSortOption}
              scrollTo={() => {}}
            />
          </FilterHeaderRight>
        </div>
        <FilterSelectedDesktop>
          <FilterSectionSelectedFilters layout="wrap" />
        </FilterSelectedDesktop>
      </FilterHeader>
      <FilterSections open={show}>
        {filters.map((filter) => (
          <FilterSection
            title={filter.name}
            handle={filter.handle}
            key={filter.id}
          >
            <Filter
              filter={filter}
              renderFilterList={({ filter, filterListProps }) => (
                <FilterSectionListSelector
                  handle={filter.handle}
                  {...filterListProps}
                />
              )}
              renderFilterRange={({ filterRangeProps }) => (
                <FilterSectionRange
                  handle={filter.handle}
                  {...filterRangeProps}
                />
              )}
              showEmptyFilters={true}
            />
          </FilterSection>
        ))}
      </FilterSections>
    </FilterContainer>
  );
};

export default FiltersDesktop;
